'use server';

import { z } from 'zod';
import { Resend } from 'resend';

const resend = new Resend('re_ZBBm33ot_CzJZ7g5JAcrDGyjBL9jYvKyL');

const contactSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters."),
  email: z.string().email("Invalid email address."),
  message: z.string().min(10, "Message must be at least 10 characters."),
});

export async function sendContactMessage(prevState: any, formData: FormData) {
  const validatedFields = contactSchema.safeParse({
    name: formData.get('name'),
    email: formData.get('email'),
    message: formData.get('message'),
  });

  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
      message: 'Validation failed.',
      success: false,
    };
  }

  const { name, email, message } = validatedFields.data;
  const to = "marcos.vazquez.rey@gmail.com";

  try {
    await resend.emails.send({
      from: 'onboarding@resend.dev', // This must be 'onboarding@resend.dev' until you verify a domain
      to: to,
      subject: `New message from ${name} on your portfolio`,
      reply_to: email,
      text: message,
    });
    return { success: true, message: "Your message has been sent successfully!" };
  } catch (error) {
    console.error(error);
    return { success: false, message: 'Failed to send message. Please try again later.' };
  }
}
